<template>
  <div data-aos="zoom-in">
    <div class="flex flex-col p-6 md:p-[100px] gap-10 md:gap-[60px]">
      <!-- Header Section -->
      <div class="flex flex-col items-center text-center">
        <h1 class="text-2xl md:text-4xl font-semibold">
          {{ getLocalized1("corevalue") }}
        </h1>
        <p class="text-sm md:text-2xl mt-2">
          {{ getLocalized1("paragraph") }}
        </p>
      </div>

      <!-- Core Value Cards -->
      <!-- <div
        class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-[60px]"
      >
        <div
          v-for="(item, index) in coreDetails"
          :key="index"
          class="max-w-sm rounded-lg p-6 mx-auto"
        >
          <div class="flex justify-center mb-4">
            <div
              class="w-12 h-12 md:w-16 md:h-16 rounded-lg flex items-center justify-center"
            >
              <slot name="icon">
                <div>
                  <img :src="item.icon_path" alt="" />
                </div>
              </slot>
            </div>
          </div>
          <h2
            class="text-base md:text-[18px] font-semibold text-gray-800 mb-3 text-center"
          >
            {{ getLocalized(item, "title") }}
          </h2>
          <p class="text-sm md:text-base text-gray-600 text-center">
            {{ getLocalized(item, "description") }}
          </p>
        </div>
      </div> -->

      <!-- New core card -->

      <div class="w-full flex flex-col gap-[50px] lg:gap-[73px]">
        <div
          class="w-full gap-[50px] grid grid-cols-1 md:grid-cols-2 lg:flex lg:justify-center lg:items-center"
        >
          <!-- Core value card icon part -->
          <div
            class="lg:w-[272.5px] flex flex-col gap-[20px] text-center items-center"
            v-for="(item, index) in coreDetails.slice(0, 4)"
            :key="index"
          >
            <!-- Icon image -->
            <span class="flex justify-center items-center">
              <img
                :src="item.icon_path"
                alt="Icon"
                class="h-auto max-h-[100px]"
              />
            </span>
            <!-- Title -->
            <h1 class="text-[18px] font-bold">
              {{ getLocalized(item, "title") }}
            </h1>
          </div>
        </div>

        <div
          class="w-full gap-[50px] justify-center grid grid-cols-1 md:grid-cols-2 lg:flex"
        >
          <!-- Core value card icon part  -->
          <div
            class="lg:w-[272.5px] flex flex-col gap-[20px] text-center"
            v-for="(item, index) in coreDetails.slice(4, 7)"
            :key="index"
          >
            <!-- Icon image -->
            <span class="flex justify-center">
              <img :src="item.icon_path" alt="" />
            </span>
            <!-- Title -->
            <span>
              <h1 class="text-[18px] font-bold">
                {{ getLocalized(item, "title") }}
              </h1>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { useLocalization } from "@/composable/useLocalization";
export default {
  data() {
    return {
      coreDetails: [],
      api: process.env.VUE_APP_API_KEY,
      translations: {
        corevalue: {
          en: "Core Value",
          kh: "គុណតម្លៃ",
        },
        paragraph: {
          en: "TURBOTECH provide service to client and make an effort to achieve :",
          kh: "TURBOTECH ផ្តល់សេវាកម្មដល់អតិថិជន និងខិតខំប្រឹងប្រែងដើម្បីសម្រេចបាននូវ៖",
        },
      },
      currentLang: localStorage.getItem("language") || "en",
    };
  },
  computed: {
    // Optionally, you can use a computed property for localization logic
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
    getLocalized1() {
      return (key) => {
        return this.translations[key]
          ? this.translations[key][this.currentLang]
          : key;
      };
    },
  },
  mounted() {
    this.fetchCoreValues();
  },
  methods: {
    async fetchCoreValues() {
      try {
        const response = await axios.get(this.api + "/api/core-values");
        this.coreDetails = response.data.items
          .map((item) => ({
            ...item,
            icon_path: `${this.api}${item.icon_path}`,
          }))
          .sort((a, b) => a.display_order - b.display_order);
      } catch (error) {
        console.error(error.message);
      }
    },
  },
};
</script>

<style></style>
